import React from 'react'
import { IconType } from 'react-icons'
import booksitoutIcon from '../config/BooksitoutIcon'
import parse from 'html-react-parser'
import styled from 'styled-components'

interface Props {
	message: string
	description?: string
	size?: '1em' | '2em' | '3em' | '4em' | '5em' | '6em'
	icon?: IconType
}

const NoContent: React.FC<Props> = ({ message = '찾으시는 내용이 없어요', description, size, icon }) => {
	const IconComponent = icon ?? booksitoutIcon.noContent

	return (
		<ContentContainer>
			<IconContainer>
				<IconComponent style={{ color: 'var(--sub-text-color)' }} size={size ?? '60px'} />
			</IconContainer>

			<Title>{parse(message)}</Title>
			{description && <Description>{parse(description)}</Description>}
		</ContentContainer>
	)
}

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 32px 40px;
`

const IconContainer = styled.div`
	margin-bottom: 16px;
`

const Title = styled.h5`
	text-align: center;
	font-weight: bold;
	font-size: 18px;
	color: var(--text-color);
	margin: 0;
`

const Description = styled.p`
	margin-top: 8px;
	text-align: center;
	font-size: 14px;
	color: var(--sub-text-color);
	margin-bottom: 0;
	white-space: pre-line;
`

export default NoContent
